var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomPlane = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.711 19.321-8.803-8.797v-3.9c0-.619-.137-1.237-.413-1.821l-.206-.378A1.412 1.412 0 0 0 15 3.6c-.55 0-1.048.31-1.289.808l-.223.43a4.314 4.314 0 0 0-.396 1.803v3.9l-8.803 8.797a2.363 2.363 0 0 0-.688 1.684v1.117a.5.5 0 0 0 .24.412.444.444 0 0 0 .482-.017l8.958-5.739c.086 1.444.207 2.63.361 4.09l.155 1.495-3.336 2.199a.46.46 0 0 0-.206.395v.945c0 .137.069.275.172.378.12.086.258.12.395.086L15 25.455l4.178.928c.034 0 .069.017.103.017a.467.467 0 0 0 .292-.103c.12-.086.172-.223.172-.378v-.945a.504.504 0 0 0-.206-.395l-3.336-2.2.155-1.494c.155-1.46.258-2.663.361-4.09l8.958 5.74a.445.445 0 0 0 .481.016.463.463 0 0 0 .241-.412v-1.117a2.279 2.279 0 0 0-.688-1.7z",
    fill: "#1E2969",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomPlane);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-plane.21a33d5fa10bff7777a1bdb4637dd997.svg";